import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { CheckClockService } from '../../services/check-clock.service';
import { EmployeeService } from '../../services/employee.service';
import { AuthService } from '../../services/auth.service';
import { PermissionService } from '../../services/permission.service';

import { Utils } from '../../util';
import { Subscription } from 'rxjs';
import { CheckClockLoadService } from '../../services/check-clock-load.service';
import { toast } from 'angular2-materialize';

@Component({
    selector: 'app-read-unregistered-employees',
    templateUrl: './read-unregistered-employees.component.html',
    styleUrls: ['./read-unregistered-employees.component.css', '../../app.component.css']
})

export class ReadUnregisteredEmployeesComponent implements OnInit, OnDestroy {
    permission: any = {};

    unregisteredEmployees: any[] = [];

    unregisteredEmployeesNumber: number;

    data: Array<any>;
    rows: Array<any> = [];
    columns: Array<any> = [
        { title: 'Folio', className: 'center', name: 'name' },
        { title: 'Fecha registro', className: 'center', name: 'registrationDatetime' },
        { title: 'Entrada / Salida', className: 'center', name: 'type' }
    ];

    page = 1;
    itemsPerPage = 10;
    maxSize = 5;
    numPages = 1;
    length = 0;
    config: any = {
        paging: true,
        sorting: { columns: this.columns },
        filtering: { filterString: '' }
    };

    checkClockLoad: any;

    gccueSubs: any;

    permissions = [];
    permissionsSubs: any;
    paramSub: Subscription;

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private checkClockLoadService: CheckClockLoadService,
                private checkClockService: CheckClockService,
                private employeeService: EmployeeService,
                private authService: AuthService,
                private permissionService: PermissionService
    ) {
        let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
            permissionsSubs.unsubscribe();
            this.permission = this.permissionService.constructPermissionObject(groups, checkClockLoadService.collection);
        });

        this.paramSub = this.activatedRoute.parent.params.subscribe(parameters => {
            this.checkClockLoad = parameters['id'];
            
            this.loadCheckClocks();
        });
    }

    ngOnInit() {

    }
    ngOnDestroy(){
        this.paramSub.unsubscribe()
    }

    loadCheckClocks() {
        this.gccueSubs = this.checkClockService.getCheckClocksUnregisteredEmployees(this.checkClockLoad).subscribe(checkClocksTemp => {
            this.gccueSubs.unsubscribe();

            this.unregisteredEmployees = [];

            let currentFolio = 0;
            let employeesConta = 0;

            for (const idx in checkClocksTemp) {
                checkClocksTemp[idx].name = checkClocksTemp[idx].folio;

                if (currentFolio !== checkClocksTemp[idx].folio) {
                    currentFolio = checkClocksTemp[idx].folio;
                    employeesConta = employeesConta + 1;
                }

                checkClocksTemp[idx].registrationDatetime = Utils.getDateTime(checkClocksTemp[idx].registrationDatetime);

                checkClocksTemp[idx].type = (checkClocksTemp[idx].type === 0) ? 'Entrada' :
                                            (checkClocksTemp[idx].type === 1) ? 'Salida' : 'Otro';

                this.unregisteredEmployees.push(checkClocksTemp[idx]);
            }

            this.unregisteredEmployeesNumber = employeesConta;

            this.data = this.unregisteredEmployees;
            this.length = this.data.length;
            this.onChangeTable(this.config);
        });
    }

    onCellClick(data: any): any {
        if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
        this.router.navigate([
            '/vw_check_clock/' + this.checkClockLoad,
            { outlets: {
                'tab_registered_employees': ['registered_employees'],
                'tab_unregistered_employees': ['add_unregistered', data.row.folio]
            } }
        ]);
    }



    // *************** Table functionality *************** //
    changePage(page: any, data: Array<any> = this.data): Array<any> {
        let start = (page.page - 1) * page.itemsPerPage;
        let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;

        return data.slice(start, end);
    }

    changeSort(data: any, config: any): any {
        if (!config.sorting) {
            return data;
        }

        let columns = this.config.sorting.columns;
        let columnName: string;
        let sort: string;

        for (let i = 0; i < columns.length; i++) {
          if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
                columnName = columns[i].name;
                sort = columns[i].sort;
            }
        }

        if (!columnName) {
            return data;
        }

        // simple sorting
        return data.sort((previous: any, current: any) => {
            if (previous[columnName] > current[columnName]) {
                return sort === 'desc' ? -1 : 1;
            } else if (previous[columnName] < current[columnName]) {
                return sort === 'asc' ? -1 : 1;
            }

            return 0;
        });
    }

    changeFilter(data: any, config: any): any {
        let filteredData: Array<any> = data;

        this.columns.forEach((column: any) => {
            if (column.filtering) {
                filteredData = filteredData.filter((item: any) => {
                    return item[column.name].match(column.filtering.filterString);
                });
            }
        });

        if (!config.filtering) {
            return filteredData;
        }

        if (config.filtering.columnName) {
            return filteredData.filter((item: any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
        }

        let tempArray: Array<any> = [];

        filteredData.forEach((item: any) => {
            let flag = false;

            this.columns.forEach((column: any) => {
                if (item[column.name] &&
                    item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
                    flag = true;
                }
            });

            if (flag) {
                tempArray.push(item);
            }
        });

        filteredData = tempArray;

        return filteredData;
    }

    onChangeTable(config: any, page: any = {page: this.page, itemsPerPage: this.itemsPerPage}): any {
        if (config.filtering) {
            Object.assign(this.config.filtering, config.filtering);
        }

        if (config.sorting) {
            Object.assign(this.config.sorting, config.sorting);
        }

        let filteredData = this.changeFilter(this.data, this.config);
        let sortedData = this.changeSort(filteredData, this.config);

        this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
        this.length = sortedData.length;
    }

}

